import React from 'react';

function OrderedList({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      // @ts-ignore TS(2783): 'stroke' is specified more than once, so this usag... Remove this comment to see the full error message
      stroke="black"
      {...otherProps}
    >
      <path d="M10 5H20" />
      <path d="M4 17H6" />
      <path d="M6 21L6 17" />
      <path d="M4 3L5 3" />
      <path d="M5 7L5 3" />
      <path d="M4 19H6" />
      <path d="M4 21H6" />
      <path d="M4 10H6" />
      <path d="M4 12H6" />
      <path d="M4 12V14" />
      <path d="M6 10V12" />
      <path d="M4 14H6" />
      <path d="M10 12H20" />
      <path d="M10 19H20" />
    </svg>
  );
}

export default OrderedList;
